/**
 * 스크린샷 캡처 유틸리티
 * 네이티브: capacitor-screenshot (정확한 화면 캡처)
 * 웹 폴백: html2canvas
 */
import { Capacitor } from "@capacitor/core";
import { createLogger } from "@ict/shared";

const logger = createLogger({ module: "Screenshot" });

/**
 * 현재 화면을 캡처하여 base64 DataURL로 반환
 */
export async function captureScreenshot(): Promise<string | null> {
  // 네이티브 플랫폼: capacitor-screenshot 사용
  if (Capacitor.isNativePlatform()) {
    try {
      const { Screenshot } = await import("capacitor-screenshot");
      const result = await Screenshot.take();
      // capacitor-screenshot은 base64만 반환 (DataURL 아님)
      return `data:image/png;base64,${result.base64}`;
    } catch (error) {
      logger.warn("네이티브 스크린샷 실패, html2canvas로 대체:", error);
    }
  }

  // 웹 폴백: html2canvas-pro (oklch/lab/lch 네이티브 지원)
  try {
    const html2canvas = (await import("html2canvas-pro")).default;

    const canvas = await html2canvas(document.body, {
      useCORS: true,
      allowTaint: true,
      backgroundColor: "#ffffff",
      scale: Math.min(window.devicePixelRatio || 1, 2),
      ignoreElements: (element: Element) => element.classList.contains("html2canvas-ignore"),
    });

    // 서버에서 Sharp로 추가 압축하므로 높은 품질로 전송
    return canvas.toDataURL("image/jpeg", 0.92);
  } catch (error) {
    logger.error("스크린샷 캡처 실패:", error);
    return null;
  }
}
